export { default as AlertText } from './alert-text';
export { default as SuccessText } from './success-text';
export { default as WarnText } from './warn-text';
export { default as InlineIconText } from './inline-icon-text';
